import request from '@/utils/request'

// 优惠券活动分页列表
export function couponActivityPageList(data = {}) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/coupon/activity/pageList',
    method: 'POST',
    data,
  })
}

// 优惠券发放领取记录分页
export function userGetCouponPageList(data = {}) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/coupon/userGetCouponPageList',
    method: 'POST',
    data,
  })
}

// 优惠券核销记录分页
export function verifyCouponPageList(data = {}) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/coupon/verifyCouponPageList',
    method: 'POST',
    data,
  })
}

// 优惠券发放领取记录导出
export function userGetCouponPageExport(data = {}) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/coupon/userGetCouponPageExport',
    method: 'POST',
    responseType: 'blob',
    isExport: true,
    data,
  })
}

// 优惠券核销记录导出
export function userVerifyCouponPageExport(data = {}) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/coupon/userVerifyCouponPageExport',
    method: 'POST',
    responseType: 'blob',
    isExport: true,
    data,
  })
}

// 优惠券模板统计详情
export function couponTemplateStatistics(data = {}) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/coupon/couponTemplateStatistics',
    method: 'POST',
    data,
  })
}

// 优惠券核销抵扣明细
export function verifyCouponDetailList(data = {}) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/coupon/verifyCouponDetailList',
    method: 'POST',
    data,
  })
}
